/**
 * Rate Limit Badge Component
 * Display rate limit information
 */

import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { colors } from '../../theme/colors';
import { typography } from '../../theme/typography';
import { spacing } from '../../theme/spacing';
import { RATE_LIMIT } from '../../utils/constants';

interface RateLimitBadgeProps {
  remaining: number;
  limit?: number;
  showWarning?: boolean;
}

export default function RateLimitBadge({
  remaining,
  limit = RATE_LIMIT.MAX_MESSAGES_PER_HOUR,
  showWarning = true,
}: RateLimitBadgeProps) {
  const percentage = (remaining / limit) * 100;
  const isLow = remaining < RATE_LIMIT.WARNING_THRESHOLD;
  const isCritical = remaining === 0;

  const badgeColor = isCritical
    ? colors.rateLimitError
    : isLow
    ? colors.rateLimitWarning
    : colors.rateLimitGood;

  if (!showWarning && !isLow) return null;

  return (
    <View style={[styles.container, { backgroundColor: badgeColor }]}>
      <Text style={styles.text}>
        {remaining} / {limit} messages
      </Text>
      {isLow && (
        <Text style={styles.warningText}>
          {isCritical ? 'Limite atteinte' : 'Limite bientôt atteinte'}
        </Text>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: spacing.md,
    paddingVertical: spacing.sm,
    borderRadius: 16,
    alignItems: 'center',
    justifyContent: 'center',
  },
  text: {
    fontSize: typography.fontSize.xs,
    fontWeight: typography.fontWeight.semibold,
    color: '#FFFFFF',
  },
  warningText: {
    fontSize: typography.fontSize.xs,
    color: '#FFFFFF',
    marginTop: spacing.xs / 2,
  },
});

